import { Injectable } from '@angular/core';
import { IpseSimulationData } from '../interfaces/pseSimulationData.interface';
import { IRatesTable } from '../interfaces/rates-table.interface';

@Injectable({
  providedIn: 'root'
})
export class RatesService {
  ratesTableMap: IRatesTable[] = [];
  simulationDataPse: IpseSimulationData = {} as IpseSimulationData;

  getRate(amount: number, days: number): number {
    let termByAmount: IRatesTable = {
      amount: null as unknown as number,
      term: []
    } as IRatesTable;
    let rate: number = null as unknown as number;

    for (let rates of this.ratesTableMap) {
      termByAmount = amount >= rates.amount ? rates : termByAmount;
    }

    if (termByAmount) {
      const termByAmountLength = termByAmount.term.length;

      for (let i = 0; i < termByAmountLength; i++) {
        rate =
          days >= termByAmount.term[i].days ? termByAmount.term[i].rate : rate;
      }
    }

    return rate;
  }
}
